<template>
    <button
      :class="[ 'inline-flex items-center justify-center font-normal transition-colors focus:outline-none text-sm lg:text-base', className ]"
      @click="handleClick"
    >
      <ArrowNarrowLeft
        class="{ 'w-5 h-5 me-2': true, 'transform rotate-180': routeLang.code.value === 'ar' || routeLang.code.value === 'he' }"
        :stroke-width="1.7"
      />
      {{ $t(label) }}
    </button>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import ArrowNarrowLeft from "@components/icons/arrow-narrow-left";

const props = defineProps({
  routeCode: {
    type: String,
    default: ROUTES.CODE.HOME
  },
  className: {
    type: String,
    default: 'text-accent hover:text-accent-hover focus:text-accent-hover'
  },
  label: {
    type: String,
    default: 'text-back'
  }
});

const { $navigationCounter } = useNuxtApp();
const router = useRouter();

const handleClick = async () => {
  if ($navigationCounter.value > 1) {
    router.back();
  } else {
    await navigatorTo(translatePath(props.routeCode));
  }
}
</script>
